import { Component, OnInit, ViewChild, ChangeDetectorRef } from '@angular/core';
import { Mxonljnl } from '@app/models/mxonljnl';
import { PersonPortalState } from '@app/models/person-portal-state'
import { MatTableDataSource } from '@angular/material/table';
import { MatPaginator } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import { LocalStorageUtilities } from '@app/utilities/local-storage-utilities';
import { MainScreenEvents } from '@app/interfaces/main-screen-events';


@Component({
  selector: 'app-account-history',
  templateUrl: './account-history.component.html',
  styleUrls: ['./account-history.component.css']
})
export class AccountHistoryComponent implements OnInit, MainScreenEvents {

  public personPortalState: PersonPortalState;
  public serviceFees: number = 0;
  public interestCharges: number = 0;
  public interestPaid: number = 0;
  public profitLoss: number = 0;

  public journals: Mxonljnl[] = [];

  public journalsDataSource = new MatTableDataSource<Mxonljnl>(this.journals);
  public journalsColumns: string[] = ['effectDate', 'description', 'unitBal'];

  @ViewChild("journalsPaginator", { static: true })
  journalsPaginator: MatPaginator;
  @ViewChild("journalsSort", { static: true })
  journalsSort: MatSort;

  constructor(private changeDetectorRefs: ChangeDetectorRef) { }

  ngOnInit() {
    this.journalsDataSource.sort = this.journalsSort;
    this.initControls();
  }

  private initControls() {
   // this.refreshUI();
    // Table paginator.
    this.journalsDataSource.paginator = this.journalsPaginator;
    // Force table to sort decendingly on tradeDate. 
    this.journalsSort.sort({ id: 'effectDate', start: 'desc', disableClear: false });
  }

  /**
   * Called from the "Main" module when the selected account changes.
   */
  public refreshUI(): void {
    this.initUI();
  }

  public initUI(): void {
    // Load table models.
    this.personPortalState = LocalStorageUtilities.getPersonPortalState();
    this.serviceFees = this.personPortalState.mxna.svcCharged;
    this.interestCharges = this.personPortalState.mxna.intCharged;
    this.interestPaid = this.personPortalState.mxna.intPaid;
    this.profitLoss = this.personPortalState.mxna.ytdProfitLoss;
    this.journals = [];
    // Load journals.     
    this.initModels();
    this.journalsDataSource.data = this.journals;
    this.changeDetectorRefs.detectChanges();
  }


  private initModels(): void {
    this.personPortalState.mxna.mxonljnl.filter((jnl) => {
      return jnl.commodity.trim() === "ZZZ" && jnl.tradeNum === "9999999" && (jnl.jnlCode === "DB" || jnl.jnlCode === "CR" || jnl.inputDesc === "CASH TRANSFER  AR");
    }).forEach((f) => {
      this.journals.push(f);
    });
  }




}
